import { useState } from "react";
import { LOGO_URL } from "../utils/constants";
import { Link } from "react-router-dom";
import { LuShoppingCart } from "react-icons/lu";
import {useSelector} from 'react-redux';

const Header = () => {
  const [btnText, setBtnText] = useState('Login');
  const cartItems=useSelector((store)=>store.cart.items)

  return (
    <div className="header w-[98%] xs:w-[99%] sm:w-[99.5%]">
      <div className="logo gap-[10px] xs:gap-4 sm:gap-[30px]">
        <img src={LOGO_URL} alt="Logo" className="w-[30px] xs:w-[50px] sm:w-[100px]"></img>
        <div className="company-name hidden xs:block text-lg sm:text-3xl">
          <Link to='/'>
            Food Panda
          </Link>
        </div>
      </div>

      <div className="nav-items">
        <ul className="text-[8px] xs:text-sm sm:text-base gap-[6px] xs:gap-2 sm:gap-[30px]">
          <li className="text-[8px] xs:text-sm sm:text-xl">
            <Link to='/'>Home</Link>
          </li>
          <li className="text-[8px] xs:text-sm sm:text-xl">
            <Link to='/about'>About</Link>
          </li>
          <li className="text-[8px] xs:text-sm sm:text-xl">
            <Link to='/contact'>Contact</Link>
          </li>
          <li className="text-[8px] xs:text-sm sm:text-xl">
            <Link to='/cart'>
            <div className="relative">
              <div className="cart-count absolute -top-1 -right-1 xs:-top-2 xs:-right-2 bg-red-500 text-white text-[6px] xs:text-xs rounded-full h-2 w-2 xs:h-4 xs:w-4 sm:h-5 sm:w-5 flex items-center justify-center">
                {cartItems.length}
              </div>
              <div className="cart-icon w-4 h-4 xs:w-8 xs:h-8 sm:w-10 sm:h-10 flex items-center justify-center text-sm xs:text-xl sm:text-2xl">
                <LuShoppingCart />
              </div>
            </div>
            </Link>
          </li>
          <li>
            <button className="login-btn text-[8px] xs:text-sm sm:text-xl px-1 py-0.5 xs:px-2 sm:px-4"
              onClick={() => {
                btnText === 'Login' ? setBtnText('Logout') : setBtnText('Login');
              }}
            >
              {btnText}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
